module.exports = __webpack_public_path__ + "static/img/apply5.56a34aca.png";